import PromiseStatuses from "../enums/promiseStatuses";

export const getRejected = (item: PromiseSettledResult<void>) => item.status === PromiseStatuses.rejected;

export const hasFulfilled = (item: PromiseSettledResult<void>) => item.status === PromiseStatuses.fulfilled;
